module.exports = __webpack_public_path__ + "static/media/Diva.3984b79f.JPG";